import React from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { CustomSider } from "./CustomSider";
import { CustomHeader } from "./CustomHeader";

const { Content } = Layout;

export const CustomLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    return (
        <Layout className="min-h-screen">
            <CustomSider />
            <Layout className="main-layout-area">
                <CustomHeader />
                <Content className="main-content-area">
                    <div className="content-wrapper">
                        {children ?? <Outlet />}
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};
